import React, { Component } from 'react'
import MaterialModal from "app/components/normal/MaterialModal"
import closeIcon from "app/styles/images/sp/close.svg"
import styled from 'styled-components'
import { Row, Input, message } from 'antd'
import cx from 'classnames'
import { observable, action, computed } from 'mobx'
import { observer } from 'mobx-react'
import request from "app/vendor/request"
import config from "app/config"

const LightBlueBlock = styled.div`
  background: rgb(241, 248, 255);
  padding: 10px 18px;
`

const SummaryLabel = styled.label`
  line-height: 30px;
  align-self: flex-start;
  flex-shrink: 0;
  text-align: right;
  width: 90px;
`

const InfoBar = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 14px;
  margin-top: 14px;
`

const InfoArea = styled.div`
  display: flex;
  align-items: center;
`

const RightArea = InfoArea.extend`
  font-size: 12px;
  color: rgb(153, 153, 153);
  font-family: 'PingFangSC-Light';
`

const Tag = styled.div`
  padding: 7px 24px;
  background-color: rgb(241, 248, 255);
  font-size: 14px;
  font-family: 'PingFangSC-Semibold';
  color: rgb(44, 112, 174);
  border-radius: 20px;
  line-height: 14px;
`

const YellowBtn = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 150px;
  height: 28px;
  margin-top: 10px;
  border-radius: 3px;
  font-size: 12px;
  background: #f8b62d;
  border: none;
  color: white;
  cursor: pointer;

  &:last-child {
    margin-right: 0;
  }
`
const GreenBtn = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 150px;
  height: 28px;
  border-radius: 3px;
  font-size: 12px;
  margin-top: 10px;
  background: rgb(88, 188, 0);
  border: none;
  color: white;
  cursor: pointer;

  &:last-child {
    margin-right: 0;
  }
`

const HiddenScrollBar = styled.div`
  overflow: hidden;
`

const BaseInfoItem = styled(Row)`
  margin-bottom: 5px;
  color: rgb(102, 102, 102);

  p {
    color: rgb(51, 51, 51);
  }

  &:last-child {
    margin-bottom: 0;
  }
`

const Line = styled.div`
  height: 1px;
  flex-grow: 1;
  background: #eeeeee;
`

const RecordWrap = styled.div`
  width: calc(100% + 18px);
  overflow-y: scroll;
  max-height: 100px;
  transition: $transtionExtend;

  &.close {
    max-height: 0;
  }
`

const RecordItemContent = styled.div`
  white-space: pre-line;
  font-family: 'PingFangSC-Regular';
  line-height: 17px;
`

const ExpandBtn = styled.div`
  cursor: pointer;
  margin-left: 6px;
  line-height: 12px;
  border-radius: 2px;
  padding: 3px 6px;
  color: white;
  border: none;
  font-weight: 300;

  &.extend-btn {
    background: #3171af;
  }

  &.close-btn {
    background: #aaa;
  }
`

const RecordItemWrap = styled.div`
  padding: 0 5px;
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0
  }
`

@observer
export default class PushModal extends Component {
  @observable summaries = {}
  @observable showCheckHistory = true
  @observable showRecheckHistory = false
  @observable checkBtnLocked = false
  @observable recheckBtnLocked = false
  @observable pushSubmitData = {
      check: {
        checkSummary: '',
        summaryAneu:'',
        stsAnomaly: '',
        type: 'check'
      },
    recheck: {
      recheckSummary: '',
      type: 'recheck'
    }
  }

  componentDidMount() {
    const { detailData } = this.props.store
    this.getSummaries(detailData.reportId)
      .then(res => {
        this.handleDataChange()
      }, err => {
        message.error(err.message)
      })
  }

  isEmptyObj = (obj) => {
    return Object.keys(obj).length === 0
  }

  parseEnter(str) {
    if (!str || typeof str !== "string") {
      return null
    }

    const strs = str.split("\n")
    const result = []

    for (var i = 0; i < strs.length - 1; i++) {
      result.push(strs[i], <br />)
    }
    return result
  }

  handleDataChange = () => {
    //输入框展示历史记录最后一条
    // const { detailData } = this.props.store
    // const summary = detailData.result && this.parseEnter(detailData.result)[0]
    // if(this.summaries.check){
    //   this.onPushDataChange('check', 'summaryAneu', this.summaries.check[0] && this.summaries.check[0].summaryAneu)
    //   this.onPushDataChange('check', 'checkSummary', this.summaries.check[0] && this.summaries.check[0].checkSummary)
    // }else if(data.appName==="AZF_Miseq"&&reportDetailResult){
    //   const reportDetailResultArr=reportDetailResult.split('\n')
    //   this.onPushDataChange('check', 'summaryAneu', reportDetailResultArr[reportDetailResultArr.length-2])
    //   this.onPushDataChange('check', 'checkSummary', summary)
    // }else{
    //   this.onPushDataChange('check', 'summaryAneu', '')
    //   this.onPushDataChange('check', 'checkSummary', summary)
    // }
    // const {reportDetailResult }= this.props
    // const reportDetailResultArr=reportDetailResult.split('\n')
    // const checkSummary=reportDetailResultArr[0]
    // const summaryAneu=reportDetailResultArr[reportDetailResultArr.length-2]

     //输入框展示原始数据
     let { reportDetailResult }= this.props
     let { STSAnomalyArr }= this.props
     if(STSAnomalyArr){
        this.onPushDataChange('check', 'stsAnomaly', STSAnomalyArr.join(';'))
     }
    if(reportDetailResult){
        const reportDetailResultArr=reportDetailResult.split('\n')
        this.onPushDataChange('check', 'summaryAneu', reportDetailResultArr[reportDetailResultArr.length-2])
        this.onPushDataChange('check', 'checkSummary', reportDetailResultArr[0])
    }
   
  }

  @action onPushDataChange = (type, field, value) => {
    this.pushSubmitData[type][field] = value
  }

  @action toggleCheckHistoryReport = () => {
    this.showCheckHistory = !this.showCheckHistory
  }

  @action toggleRecheckHistoryReport = () => {
    this.showRecheckHistory = !this.showRecheckHistory
  }

  @computed get isCheckModify() {
    const pushSummary = this.pushSubmitData.check.checkSummary
    const pushSummaryAneu = this.pushSubmitData.check.summaryAneu
    const pushSTSAnomalyAneu = this.pushSubmitData.check.stsAnomaly
    if (this.summaries.check) {//有历史记录
      const { checkSummary ,summaryAneu,stsAnomaly} = this.summaries.check[0]
      const isEqualCheckSummary = pushSummary === checkSummary
      const isEqualSummaryAneu = pushSummaryAneu === summaryAneu
      const isEqualSTSAnomalyAneu = pushSTSAnomalyAneu === stsAnomaly
      if (isEqualCheckSummary&&isEqualSummaryAneu&&isEqualSTSAnomalyAneu) {
        return false
      }
    }
    return true
  }

  @computed get isReCheckModify() {
    const pushSummary = this.pushSubmitData.recheck.recheckSummary
    if (this.summaries.recheck) {
      const { recheckSummary } = this.summaries.recheck[0]
      const isEqualRecheckSummary = pushSummary === recheckSummary
      if (isEqualRecheckSummary) {
        return false
      }
    }
    return true
  }

  @action handlePush = () => {
    const {
      store: {
        detailData
      },
      groupId,
      closeModal,
    } = this.props
    // const summaryId = this.summaries.recheck[0].id
    const summaryId = this.summaries.check[0].id

    return request.post(`${config.backend}/azf/reports/notice/${detailData.reportId}?` +
      `summaryId=${summaryId}&groupId=${groupId}`)
      .checkToken()
      .commonDispose()
      .then(res => {
        message.success(res.msg)
        closeModal()
        return Promise.resolve()
      }, err => {
        message.error(err.message)
      })
  }

  @action saveReport = (type,push) => {
    const { detailData } = this.props.store
    const {
      closeModal
    } = this.props
    this.checkbtnLocked = true
    var data=this.pushSubmitData[type]
    if(push==='push'){//保存并推送
      data.type='recheck'
    }
    if(this.isCheckModify){// 做过修改了先保存后提交
      return request.post(`${config.backend}/azf/reports/${detailData.reportId}/summaries`)
      .checkToken()
      .send(data)
      .commonDispose()
      .then(
        res => {
          this.getSummaries(detailData.reportId)
            .then(res => {
              if (push === 'push') {
                return this.handlePush()
              } else {
                message.success('报告结论保存成功')
                // message.success(res.msg)
                closeModal()
              }
            })
        },
        err => {
          message.error(err.message)
          return Promise.reject(err)
        }
      ).finally(
        res => this.checkbtnLocked = false
      )
    }else{// 否则直接提交
      return this.handlePush()
    }
    
  }

  @action getSummaries = (reportId) => {
    return request.get(`${config.backend}/azf/reports/${reportId}/summaries`)
      .checkToken()
      .commonDispose()
      .then(
        res => {
          this.summaries = res
          return Promise.resolve(res)
        },
        err => {
          message.error(err.message)
          return Promise.reject()
        }
      )
  }

  renderCheckAudit = () => {
    const { showCheckHistory } = this
    const extendBtnClass = cx({
      "close-btn": showCheckHistory,
      "extend-btn": !showCheckHistory
    })
    const RecordWrapClass = cx({
      "push-record-table": true,
      "close": !showCheckHistory,
    })
    return (
      <div>
        <Row style={{ flexWrap: 'nowrap', marginTop: 10 }} type='flex' align='middle' justify=''>
          <SummaryLabel>生信报告结论：</SummaryLabel>
          <Input
            autosize={true}
            style={{ maxHeight: 86, lineHeight: '17px', fontFamily: 'PingFangSC-Regular', padding: 8 }}
            placeholder='请输入生信报告结论'
            type='textarea'
            value={this.pushSubmitData.check.checkSummary}
            onChange={(e) => this.onPushDataChange('check', 'checkSummary', e.target.value)}
          />
        </Row>
        <Row style={{ flexWrap: 'nowrap', marginTop: 10 }} type='flex' align='middle' justify=''>
          <SummaryLabel>生信核型结论：</SummaryLabel>
          <Input
            autosize={true}
            style={{ maxHeight: 86, lineHeight: '17px', fontFamily: 'PingFangSC-Regular', padding: 8 }}
            placeholder='请输入生信核型结论'
            type='textarea'
            value={this.pushSubmitData.check.summaryAneu}
            onChange={(e) => this.onPushDataChange('check', 'summaryAneu', e.target.value)}
          />
        </Row>
         <Row style={{ flexWrap: 'nowrap', marginTop: 10 }} type='flex' align='middle' justify=''>
          <SummaryLabel>STS异常位点：</SummaryLabel>
          <Input
            autosize={true}
            style={{ maxHeight: 86, lineHeight: '17px', fontFamily: 'PingFangSC-Regular', padding: 8 }}
            placeholder='请输入STS异常位点'
            type='textarea'
            value={this.pushSubmitData.check.stsAnomaly || ''}
            onChange={(e) => this.onPushDataChange('check', 'stsAnomaly', e.target.value)}
          />
        </Row>
        <Row type='flex' align='middle' justify='center'>
          <YellowBtn
            onClick={() => {
              this.isCheckModify ? !this.checkBtnLocked && this.saveReport('check') : message.error('请在修改报告结论后保存')
            }}
          >
            保存结果
          </YellowBtn>
          <GreenBtn
            onClick={() => {
             
              !this.checkBtnLocked && this.saveReport('check','push')
             
            }}
          >
            保存并推送
          </GreenBtn>
        </Row>
        <Row style={{ marginTop: 10 }} type='flex' justify='start' align='middle' className='subtitle history'>
          <i></i>
          <b>历史记录（{this.summaries.check ? this.summaries.check.length : 0}条）</b>
          <Line></Line>
          <ExpandBtn onClick={this.toggleCheckHistoryReport} className={extendBtnClass}>
            {showCheckHistory ? "收起" : "展开"}
          </ExpandBtn>
        </Row>
        <HiddenScrollBar>
          <RecordWrap className={RecordWrapClass}>
            {
              this.summaries.check && this.summaries.check.map((item) => {
                return (
                  <RecordItem
                    key={item.id}
                    store={this.props.store}
                    data={item}
                  />
                )
              })
            }
          </RecordWrap>
        </HiddenScrollBar>
      </div>
    )
  }

  renderRecheckAudit = () => {
    const { showRecheckHistory } = this
    const extendBtnClass = cx({
      "close-btn": showRecheckHistory,
      "extend-btn": !showRecheckHistory
    })
    const RecordWrapClass = cx({
      "push-record-table": true,
      "close": !showRecheckHistory,
    })
    return (
      <div>
        {/* <Row style={{ flexWrap: 'nowrap', marginTop: 20 }} type='flex' align='middle' justify=''>
          <SummaryLabel>临检报告结论：</SummaryLabel>
          <Input
            autosize={true}
            style={{ maxHeight: 86, lineHeight: '17px', fontFamily: 'PingFangSC-Regular', padding: 8 }}
            placeholder='请输入临检报告结论'
            type='textarea'
            value={this.pushSubmitData.recheck.recheckSummary}
            onChange={(e) => this.onPushDataChange('recheck', 'recheckSummary', e.target.value)}
          />
        </Row>
        <Row type='flex' align='middle' justify='center'>
          <GreenBtn
            onClick={() => {
              this.isReCheckModify ? !this.recheckBtnLocked && this.saveReport('recheck') : message.error('请在修改报告结论后保存')
            }}
          >
            保存并推送
          </GreenBtn>
        </Row> */}
        <Row style={{ marginTop: 20 }} type='flex' justify='start' align='middle' className='subtitle history'>
          <i></i>
          <b>临检报告历史记录（{this.summaries.recheck ? this.summaries.recheck.length : 0}条）</b>
          <Line></Line>
          <ExpandBtn onClick={this.toggleRecheckHistoryReport} className={extendBtnClass}>
            {showRecheckHistory ? "收起" : "展开"}
          </ExpandBtn>
        </Row>
        <HiddenScrollBar>
          <RecordWrap className={RecordWrapClass}>
            {
              this.summaries.recheck && this.summaries.recheck.map((item) => {
                return (
                  <RecordItem
                    key={item.id}
                    store={this.props.store}
                    data={item}
                  />
                )
              })
            }

          </RecordWrap>
        </HiddenScrollBar>
      </div>
    )
  }

  render() {
    let {
      closeModal,
      data = {},
      store: { detailData }
    }
      = this.props

    return (
      <MaterialModal
        wrapClassName='push-modal-wrap'
        draggable={true}
        className="push-modal"
        title="报告审核"
        visible={true}
        width={800}
        mask={false}
        footer={false}
      >
        <img
          className="pgx-modal-close"
          src={closeIcon}
          alt="关闭对话框"
          onClick={() => {
            closeModal()
          }}
        />
        <LightBlueBlock>
          <BaseInfoItem type='flex' align='middle' justify=''>
            <label>文件名称：</label>
            <p>{!this.isEmptyObj(detailData) ? detailData.dataName : ""}</p>
          </BaseInfoItem>
          <BaseInfoItem type='flex' align='middle' justify=''>
            <label>所在分组：</label>
            <p>{data.groupName}</p>
          </BaseInfoItem>
          <BaseInfoItem type='flex' align='middle' justify=''>
            <label>样本名称：</label>
            <p>{!this.isEmptyObj(detailData) ? detailData.sampleName : []}</p>
          </BaseInfoItem>
        </LightBlueBlock>
        {this.renderCheckAudit()}
        {this.renderRecheckAudit()}
      </MaterialModal>
    )
  }
}

class RecordItem extends Component {
  renderRecordContent = () => {
    const { data } = this.props
    return (
      <RecordItemContent>
        {data.type === 'recheck' ? '临检' : '生信'}报告结论：
        {data.type === 'recheck' ? (data.recheckSummary || 'unknown') : (data.checkSummary || 'unknown')}
        <br/>
        {data.type === 'recheck' ? '' : `生信核型结论: ${data.summaryAneu || ''}`}
        <br/>
        {data.type === 'recheck' ? '' : `STS异常位点: ${data.stsAnomaly || ''}`}
       
      </RecordItemContent>
    )
  }

  render() {
    const { data } = this.props
    return (
      <RecordItemWrap>
        {this.renderRecordContent()}
        <InfoBar>
          <InfoArea>
            {data.send ? (
              <Tag>已复核</Tag>) : (<Tag>已审核</Tag>)
            }
          </InfoArea>
          <RightArea>
            保存时间：{data.updateAt}
          </RightArea>
        </InfoBar>
      </RecordItemWrap>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/normal/azf/ReportDetail/PushModal.js